module.exports = __webpack_public_path__ + "img/yun_bei_nodata.583b5213.png";